export default __webpack_public_path__ + "1352b5cbc4412824c7d59e5c72c7ec19.jpg";